import { readonly, ref } from 'vue';

const ROTAS_QUE_CONCLUEM_ACAO = ['/solicitar-autorizacao'];

const acaoConcluida = ref(false);

export const acaoConcluidaNaSessao = readonly(acaoConcluida);

export function registrarAcaoConcluida() {
  acaoConcluida.value = true;
}

export function concluiAcaoDoUsuario(url?: string) {
  if (!url) return false;
  return ROTAS_QUE_CONCLUEM_ACAO.some((rota) => url.includes(rota));
}
